import React from "react";
import { Helmet } from "react-helmet";

import { Tenant } from "@bonliva-crm/shared";

import { useTenant } from "../tenant/tenant";

type AppTitleHelmetProps = {
  signInAs?: string | null;
};

export const AppTitleHelmet: React.FC<AppTitleHelmetProps> = ({ signInAs }) => {
  const { tenant } = useTenant();
  const baseTitle = tenant === Tenant.WCC ? "WCC CRM" : "Bonliva CRM";
  const title = signInAs ? `${baseTitle} (${signInAs})` : baseTitle;

  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
};
